import { React } from "react";

import ProjectCard from "./ProjectCard/ProjectCard";
import "./FeaturedProjects.scss";
// Import Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';

export default function FeaturedProjects(props) {
  const data = props.data || [];

  const mappedProjectCards = Array.isArray(data) 
    ? data.map((project) => (
        <SwiperSlide key={project.project_id}>
          <ProjectCard
            projectId={project.project_id}
            title={project.title}
            imageUrl={project.imageUrl}
            location={project.location}
            members={project.members}
            summary={project.summary}
          ></ProjectCard>
        </SwiperSlide>
      ))
    : [];

  return (
    <div className="featured_container">
      <h1 className="site_main_header">Featured Projects</h1>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 4000 }}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {mappedProjectCards}
      </Swiper>
    </div>
  );
}
